"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QualsDueDateType = void 0;
var QualsDueDateType;
(function (QualsDueDateType) {
    QualsDueDateType["OVERDUE"] = "OVERDUE";
    QualsDueDateType["WITHIN_6_MONTHS"] = "WITHIN_6_MONTHS";
    QualsDueDateType["MORE_THAN_6_MONTHS"] = "MORE_THAN_6_MONTHS";
})(QualsDueDateType = exports.QualsDueDateType || (exports.QualsDueDateType = {}));
